// The More filters trigger and its panel: every folded filter as a complete editor, in configured order,
// with no nested popover. The bar keeps an open panel's editors until it closes.

import React from 'react'
import PropTypes from 'prop-types'

import { Menu } from '@CommonComponents/buttons'
import { useTable } from '../context'
import { filterTypeOf } from '../query'
import { triggerText } from './drafts'
import { EnumEditor } from './EnumFilter'
import { triggerClass, useOpenReporter } from './FilterMenu'
import { RangeEditor } from './RangeEditor'
import { MORE_KEY } from './useFilterOverflow'

export const MORE_FILTERS = 'More filters'

export const moreFiltersName = activeCount =>
  activeCount > 0
    ? `${activeCount} active filters in more filters`
    : MORE_FILTERS

export const Editor = ({ column }) => {
  const type = filterTypeOf(column)
  if (type === 'numeric' || type === 'date')
    return <RangeEditor column={column} type={type} />
  return <EnumEditor column={column} />
}

Editor.propTypes = {
  column: PropTypes.object.isRequired,
}

/**
 * @param {{columns: object[], activeCount: number}} props the editors to list, and how many folded filters
 *   are active
 */
export const MoreFilters = ({ columns, activeCount }) => {
  const { state } = useTable()
  const onOpenChange = useOpenReporter(MORE_KEY)
  return (
    <Menu
      mode="panel"
      label={moreFiltersName(activeCount)}
      surfaceLabel={MORE_FILTERS}
      onOpenChange={onOpenChange}
      align="end"
      valueLabel={
        <>
          {MORE_FILTERS}
          {activeCount > 0 && (
            <span className="me-badge-tint me-badge-tint-brand me-table-filter-count">
              {activeCount}
            </span>
          )}
        </>
      }
      className={triggerClass(activeCount > 0)}
    >
      <div className="me-table-filter-panel me-table-filter-more">
        {columns.map(column => (
          <div
            key={column.key}
            className="me-table-filter-block"
            role="group"
            aria-label={column.label}
          >
            <div className="me-table-filter-heading">
              {triggerText(column, state.query.filters[column.key])}
            </div>
            <Editor column={column} />
          </div>
        ))}
      </div>
    </Menu>
  )
}

MoreFilters.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  activeCount: PropTypes.number.isRequired,
}
